/**
 * Welcome Route Component
 *
 * Uses withStoreProvider to:
 * 1. Get VM from AppContext (welcomeStore())
 * 2. Provide VM to WelcomePage via Provider
 * 3. SocialLoginVM is accessed directly via useAppContext in the page
 *
 * Pattern eliminates 7 lines of boilerplate per route
 */

import { withStoreProvider } from "@innolab-trader/vm-core";
import { useAppContextStore } from "../models/appContext";
import { WelcomeStoreProvider } from "../models/welcome";
import WelcomePage from "../pages/WelcomePage";

/**
 * Welcome Route Component
 * No loader needed - public route
 */
export const WelcomeRoute = withStoreProvider({
  useStore: () => useAppContextStore().actions.welcomeStore(),
  Provider: WelcomeStoreProvider,
  Page: WelcomePage,
});
